export default __webpack_public_path__ + "static/media/mint.062b3ef5.png";